module.exports = __webpack_public_path__ + "img/alfie-m11.a827c67b.jpeg";